import React from "react";
import SimpleImageSlider from "react-simple-image-slider";

import engaged1 from "./images/engaged1.webp";
import engaged2 from "./images/engaged2.webp";
import engaged3 from "./images/engaged3.webp";
import BulgarianRose from "./images/bulgarian-rose.webp";

const images = [
  { url: engaged1 },
  { url: engaged2 },
  { url: engaged3 },
];

function EngagedSectionSlider({ width = "420", height = "600" }) {
  return (
    <div className="relative">
      <SimpleImageSlider
        width={width}
        height={height}
        images={images}
        showBullets={true}
        showNavs={true}
        autoPlay={true}
        navMargin={8}
      />
      <div className="bulgarian-rose">
        <img
          style={{ width: "100%" }}
          src={BulgarianRose}
          alt="Bulgarian Rose"
        ></img>
      </div>
    </div>
  );
}

export default EngagedSectionSlider;
